import { useEffect, useState } from 'react';
import moment from 'moment';
import { mapAndJoinArray } from '../../../util/helperFunctions';
import { fetchDataForPage, fetchDataForUser } from '../../../api/statisticsApi';

// Utility function to build the filter string
export const buildFilter = (selectedSite, startDate, endDate) => {
    return `site IN (${selectedSite.map(site => `'${site.value.replace(/'/g, "''")}'`).join(', ')}) AND eventTime >= '${startDate.format("YYYY-MM-DD")}' AND eventTime < '${moment(endDate).add(1, "day").format("YYYY-MM-DD")}' AND userId Like '%@shell.com'`;
};

// Utility function to process statistic data
export const processStatisticData = (statisticData) => {
    if (!statisticData?.length) return null;

    const total = statisticData.reduce((pre, curr) => pre + curr.count, 0);
    return statisticData.map(item => ({
        user: item.user,
        views: item.count,
        viewsPrecentage: Math.round((item.count / total) * 100),
    }));
};

// Utility function to process page data
export const processPageData = (pageData, statisticData) => {
    if (!statisticData?.length) return null;

    return pageData.map(obj => {
        const count = statisticData.reduce((acc, cur) => 
            cur?.user === obj.user ? acc + 1 : acc, 0);
        obj.page = count;
        return obj;
    });
};

const useUserData = (selectedSite, startDate, endDate) => {
    const [userPageData, setUserPageData] = useState(null);
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const filter = buildFilter(selectedSite, startDate, endDate);
            const statisticData = await fetchDataForUser(filter);
            console.log("Fetched User Data:", statisticData);
            setLoading(false);
            const processedData = processStatisticData(statisticData);
            if (processedData) {
                console.log("User Data:", processedData);
                setPageData(processedData);
            } else {
                setUserPageData(null);
            }
        };

        fetchData();
    }, [selectedSite, startDate, endDate]);

    useEffect(() => {
        const fetchPageData = async () => {
            if (pageData?.length > 0) {
                setLoading(true);
                const filter = buildFilter(selectedSite, startDate, endDate);
                const statisticData = await fetchDataForPage(filter);
                setLoading(false);
                const processedPageData = processPageData(pageData, statisticData);
                setUserPageData(processedPageData);
            }
        };

        fetchPageData();
    }, [pageData, selectedSite, startDate, endDate]);

    return { userPageData, loading };
};

export default useUserData;